import * as Icons from '@ant-design/icons';
import { CanAccess, IResourceComponentsProps } from '@refinedev/core';
import { CreateButton, EditButton, TextField, useTable } from '@refinedev/antd';
import { IPaymentMethodRules } from '../../../interfaces/payment_methods-rules';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { Table } from 'antd';

export const PaymentMethodRulesList: React.FC<
  IResourceComponentsProps
> = () => {
  const { tableProps } = useTable<IPaymentMethodRules>();

  return (
    <>
      <ListLayout
        title="Regras de Métodos de Pagamento"
        headerActions={
          <CanAccess resource="offers/payment_method_rules" action="create">
            <CreateButton icon={<Icons.PlusOutlined />}>
              Criar Nova Regra
            </CreateButton>
          </CanAccess>
        }
      >
        <Table {...tableProps} rowKey="id">
          <Table.Column
            dataIndex="name"
            key="name"
            title="Nome da Regra"
            render={value => <TextField value={value} />}
          />

          <Table.Column<IPaymentMethodRules>
            dataIndex={['config', 'credit_card']}
            key="interest"
            title="Cartão de crédito"
            render={value => (value.length > 0 ? `${value.length}x` : '-')}
          />
          <Table.Column<IPaymentMethodRules>
            dataIndex={['config', 'financing_credit_card']}
            key="fee"
            title="Crédito Recorrente"
            render={value => (value.length > 0 ? `${value.length}x` : '-')}
          />
          <Table.Column<IPaymentMethodRules>
            dataIndex={['config', 'pix']}
            key="fee"
            title="Pix"
            render={value => (value.length > 0 ? `${value.length}x` : '-')}
          />
          <Table.Column<IPaymentMethodRules>
            dataIndex={['config', 'boleto']}
            key="fee"
            title="Boleto"
            render={value => (value.length > 0 ? `${value.length}x` : '-')}
          />
          <Table.Column<IPaymentMethodRules>
            dataIndex={'actions'}
            key="actions"
            title="Editar"
            align="center"
            width={80}
            render={(_, record) => (
              <CanAccess resource="offers/payment_method_rules" action="edit">
                <EditButton
                  hideText
                  size="small"
                  icon={<Icons.EyeOutlined />}
                  recordItemId={record.id}
                />
              </CanAccess>
            )}
          />
        </Table>
      </ListLayout>
    </>
  );
};
